import React from 'react';
import { TextBox, EmailBox } from 'fw/forms';
import { Label } from 'fw/components';
import { PhoneBox } from 'areas/shared/controls'
import { Row, Col, FormGroup, Button } from 'react-bootstrap';
import { TooltipCode } from 'areas/shared/consts';
import { PointOfContactListHelpers } from 'areas/shared/helpers';

class PointOfContactList extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = props => {
        return {
            form: {
                pointOfContactList: props.pointOfContactList,
            },
            tooltips: props.tooltips
        };
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.pointOfContactList instanceof Array) {
            this.setState({
                form: { pointOfContactList: nextProps.pointOfContactList }
            });
        }
    }

    render() {
        let me = this;
        let rows = this.state.form.pointOfContactList.map((item, index) => {
            return (
                <div key={item.pointOfContactId}>
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Col md={5}>
                                    <FormGroup>
                                        <Label htmlFor='firstName' tip={PointOfContactListHelpers.setTip(TooltipCode.POINT_OF_CONTACT.FIRSTNAME, me.state.tooltips)} required>
                                            First Name
                                        </Label>
                                        <TextBox
                                            name='firstName'
                                            placeholder="First Name"
                                            maxLength={40}
                                            value={item.firstName}
                                            onChange={e => PointOfContactListHelpers.handleChangePointOfContact(index, e, 'firstName', me.state.pointOfContactList, me.props.onUpdatePointOfContactList)}
                                            disabled={me.props.isRenewal}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={1}></Col>
                                <Col md={5}>
                                    <FormGroup>
                                        <Label htmlFor='title' tip={PointOfContactListHelpers.setTip(TooltipCode.POINT_OF_CONTACT.TITLE, me.state.tooltips)}>
                                            Title
                                        </Label>
                                        <TextBox name='title'
                                            placeholder="Title"
                                            maxLength={50}
                                            value={item.title}
                                            onChange={e => PointOfContactListHelpers.handleChangePointOfContact(index, e, 'title', me.state.pointOfContactList, me.props.onUpdatePointOfContactList)}
                                            disabled={me.props.isRenewal} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={5}>
                                    <FormGroup>
                                        <Label htmlFor='lastName' tip={PointOfContactListHelpers.setTip(TooltipCode.POINT_OF_CONTACT.LASTNAME, me.state.tooltips)} required>
                                            Last Name
                                        </Label>
                                        <TextBox
                                            name='lastName'
                                            placeholder="Last Name"
                                            maxLength={40}
                                            value={item.lastName}
                                            onChange={e => PointOfContactListHelpers.handleChangePointOfContact(index, e, 'lastName', me.state.pointOfContactList, me.props.onUpdatePointOfContactList)}
                                            disabled={me.props.isRenewal}
                                        />
                                    </FormGroup> 
                                </Col>
                                <Col md={1}></Col>
                                <Col md={5}>
                                    <FormGroup>
                                        <Label htmlFor='email' tip={PointOfContactListHelpers.setTip(TooltipCode.POINT_OF_CONTACT.EMAIL, me.state.tooltips)} required>
                                            Email
                                        </Label>
                                        <EmailBox
                                            name='email'
                                            placeholder='Email'
                                            value={item.email}
                                            onChange={e => PointOfContactListHelpers.handleChangePointOfContact(index, e, 'email', me.state.pointOfContactList, me.props.onUpdatePointOfContactList)}
                                            disabled={me.props.isRenewal}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
							<Row>
								<Col md={5}>
                                    <FormGroup>
                                        <Label htmlFor='primaryPhone' required>
                                            Primary phone
                                        </Label>
										<div className="form-inline">
											<PhoneBox
												disabled={me.props.disabled}
												name='primaryPhone'
												placeholder='Primary Phone'
												value={item.primaryPhone}
												onChange={e => PointOfContactListHelpers.handleChangePointOfContact(index, e, 'primaryPhone', me.state.pointOfContactList, me.props.onUpdatePointOfContactList)}
												ref={`primaryPhone_${index}`}
											/>
										</div>
                                    </FormGroup>
                                </Col>
								<Col md={1}></Col>
								<Col md={5}>
                                    <FormGroup>
                                        <Label htmlFor='secondaryPhone'>
                                            Secondary phone
                                        </Label>
										<div className="form-inline">
											<PhoneBox
												disabled={me.props.disabled}
												name='secondaryPhone'
												placeholder='Secondary Phone'
												value={item.secondaryPhone}
												onChange={e => PointOfContactListHelpers.handleChangePointOfContact(index, e, 'secondaryPhone', me.state.pointOfContactList, me.props.onUpdatePointOfContactList)}
												ref={`secondaryPhone_${index}`}
											/>
										</div>
                                    </FormGroup>
                                </Col>
							</Row>
                        </Col>
                    </Row>
                    {!me.props.disabled && <Row>
                        <Col md={6}>
                            <FormGroup>
                                {index === me.state.form.pointOfContactList.length - 1 ? (
                                    <Button onClick={() => me.props.addPointOfContact(me.state.form.pointOfContactList.length)} bsSize='xsmall'>
                                        Add Point of Contact
                                    </Button>
                                ) : null}
                                &nbsp;&nbsp;
                                <Button onClick={() => PointOfContactListHelpers.handleDeletePointOfContact(index, me.props.onDeletePointOfContact)} bsSize='xsmall'>
                                    Remove Point of Contact
                                </Button>
                            </FormGroup>
                        </Col>
                    </Row>}
                    <Row>
                        <Col md={12}>
                            <hr />
                        </Col>
                    </Row>
                </div>
            );
        });

        return (
            me.state.form.pointOfContactList.length === 0 ? (
                <Button onClick={() => me.props.addPointOfContact(me.state.form.pointOfContactList.length)} bsSize='xsmall'>
                    Add Point of Contact
                </Button>
            ) :
                <React.Fragment>{rows}</React.Fragment>
        )
    }
}

export default PointOfContactList;



// WEBPACK FOOTER //
// ./src/areas/certification/steps/veteranOwnerInfo/PointOfContactList.js